export default __webpack_public_path__ + "static/media/gcp.1b20e46e.svg";